import { render, staticRenderFns } from "./recruiter-registeration.vue?vue&type=template&id=97c5996e&scoped=true"
import script from "./recruiter-registeration.vue?vue&type=script&lang=js"
export * from "./recruiter-registeration.vue?vue&type=script&lang=js"
import style0 from "./recruiter-registeration.vue?vue&type=style&index=0&id=97c5996e&prod&lang=scss"
import style1 from "./recruiter-registeration.vue?vue&type=style&index=1&id=97c5996e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c5996e",
  null
  
)

export default component.exports